<template>
  <div class="dropdown" ref="dropdownBox" :style="'width:' + width" @click.stop.prevent>
    <div class="dropdown-title">
      <img src="@/assets/images/icons/search/close.png" class="close" @click.prevent="closeDowndown">
    </div>

    <div class="dropdown-content" ref="dropdownContent" :style="'min-height:' + dropDownHeight.minHeight + 'px;max-height:' + dropDownHeight.maxHeight + 'px;height:' + dropDownHeight.height + 'px'">
      <iscroll-view class="scroll-view" :options="{disableTouch: true, momentum: false, mouseWheel: true, scrollbars: true, fadeScrollbars: false, interactiveScrollbars: false, snap: true}" ref="iscroll">
        <transition @enter="enter" @leave="leave">
          <div :class="$style.dropdownContentPadding" v-if="showSelectMod" ref="selectModContent" key="selectModContent">
            <XTabs class="dropdown-content-tab" :value="currentTab" @changed="tabChanged">
              <XTabPane
                :label="$t('query.dropdown.export.frequent')"
                name="t1"
                v-if="exporterData && exporterData.hot && exporterData.hot.length > 0">
                  <Row :gutter="15">
                    <Col
                      span="6"
                      :class="['ellipsis', {active: _.trim(value) === _.trim(item.name)}]"
                      v-for="(item, index) in exporterData.hot"
                      :key="'export-col-hot-' + index">
                        <a href="#" :_id="item.id" @click.prevent="selectItem">{{item.name}}</a>
                    </Col>
                  </Row>
              </XTabPane>
              <XTabPane
                :label="$t('query.dropdown.export.fta')"
                name="t2"
                v-if="exporterData && exporterData.fta && exporterData.fta.length > 0">
                  <EDI :data="exporterData.fta" :activeName="value" @selectItem="selectItem" />
              </XTabPane>
              <XTabPane
                :label="$t('query.dropdown.export.country')"
                name="t3"
                v-if="exporterData && exporterData.continent && exporterData.continent.length > 0">
                  <EDI :data="exporterData.continent" :activeName="value" @selectItem="selectItem" />
              </XTabPane>
            </XTabs>

            <XTabs class="dropdown-content-history" :value="currentTab" v-if="historyList && historyList.length > 0" v-show="productReady">
              <XTabPane :label="$t('query.dropdown.export.recent')" name="t4">
                <Row :gutter="15">
                  <Col span="6" class="ellipsis" v-for="(v, i) in historyList" :key="'history-ex-item-' + i" v-if="!_.isEmpty(_.trim(v.id))">
                    <a href="#" :_id="v.id" @click.prevent="selectItem">{{v.text}}</a>
                  </Col>
                </Row>
              </XTabPane>
            </XTabs>
          </div>
          <div :class="$style.dropdownContentPadding" v-else ref="autoModContent" key="autoModContent">
            <transition-group tag="ul" :css="false" @before-enter="beforeLiEnter" @enter="LiEnter" @leave="LiLeave">
              <li v-for="(item, index) in exportList" :key="'ex-item-' + index" :data-index="index">
                <a class="ellipsis" href="#" :_id="item.id" @click.prevent="selectItem" v-html="highlight(item.name, value)"></a>
              </li>
              <li class="ellipsis empty" key="ex-item--1" v-show="exportList.length == 0">
                <i>{{$t('query.empty')}}</i>
              </li>
            </transition-group>
          </div>
        </transition>
      </iscroll-view>
    </div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
// eslint-disable-next-line
import VelocityUI from 'velocity-animate/velocity.ui'
import EDI from './ExportDropdownItem'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')
const { mapState: mapSearchState } = createNamespacedHelpers('search')

export default {
  name: 'ExportDropdown',
  components: { EDI },
  props: {
    exporterData: {
      type: Object,
      default: {},
      required: true,
     
    },
    currentTab: {
      type: String,
      default: 't1',
      require: true
    },
    value: {
      type: String,
      require: true
    },
    dropDownHeight: {
      type: Object
    },
    width: {
      type: String,
      default: '100%',
      require: false
    },
    defaultWidth: {
      type: String,
      default: '100%',
      require: false
    }
  },
  data () {
    return {
      showSelectMod: !this.value,
      exportList: []
    }
  },
  watch: {
    value (newVal, oldVal) {
      this.showSelectMod = this._.trim(newVal) === ''
      this.exportList = this.getAutoCompleteExporter()(newVal)
    }
  },
  computed: {
    ...mapDataState({
     
      productReady: state => state.productReady
    }),
    ...mapSearchState({
      historyList: state => state.history.exporter
    })
  },
  updated () {
    this.$nextTick(() => {
      try {
        this.updateContentHeight()
        this.refresh()
      } catch (e) {}
    })
  },
  methods: {
    closeDowndown () {
      this.$parent.closeDowndown()
    },
    setDefault (hasText) {
      this.showSelectMod = !hasText
      let xTabs = this.$refs.iscroll.$children.filter(item => item.$options['_componentTag'] === 'XTabs')
      this._.each(xTabs, (xTab) => {
        xTab.activeKey = this.currentTab
      })
    },
    selectItem (event) {
      let target = event.target
      if (!target.getAttribute('_id')) {
        target = target.parentNode
      }
      let id = target.getAttribute('_id')
      let text = this._.trim(target.innerText)
      this.$emit('selectItem', id, text)
    },
    refresh () {
      this.$refs.iscroll && this.$refs.iscroll.refresh()
    },
    updateContentHeight () {
      let contentEl = this.$refs.autoModContent ? this.$refs.autoModContent : this.$refs.selectModContent
      let dropdownContentHeight = this._h.getOffset(contentEl).height
      let maxHeight = this._h.getWinHeight() - (this._h.getScrollTop() + this._h.getOffset(this.$parent.$el).bottom) - 50
      maxHeight = this._.max([this.dropDownHeight.maxHeight, maxHeight])
      this.dropDownHeight.maxHeight = maxHeight
      this.dropDownHeight.height = this._.min([dropdownContentHeight, maxHeight])
    },
    enter (el, done) {
      if (this.width !== this.defaultWidth) {
        Velocity(el, 'transition.slideLeftBigIn', { duration: 150 })
      }
      Velocity(this.$refs.dropdownBox, {width: this.showSelectMod ? this.width : this.defaultWidth}, { duration: 150, complete: done })
    },
    leave (el, done) {
      let vm = this
      Velocity(el, 'transition.slideLeftBigOut', {
        duration: 150,
        complete: () => {
          done()
          vm.refresh()
        }
      })
    },
    beforeLiEnter (el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    LiEnter (el, done) {
      let delay = 0
      if (el.dataset) {
        delay = el.dataset.index * 5
      }
      setTimeout(() => {
        Velocity(
          el,
          { opacity: 1, height: '18px' },
          {
            complete: () => {
              this.updateContentHeight()
              this.refresh()
              done()
            }
          }
        )
      }, delay)
    },
    LiLeave (el, done) {
      let delay = 0
      if (el.dataset) {
        delay = el.dataset.index * 5
      }
      setTimeout(() => {
        Velocity(
          el,
          { opacity: 0, height: 0 },
          {
            complete: () => {
              this.updateContentHeight()
              this.refresh()
              done()
            }
          }
        )
      }, delay)
    },
    tabChanged (name) {
      this.updateContentHeight()
      this.refresh()
    },
    ...mapDataGetters([
      'getAutoCompleteExporter'
    ]),
    highlight (v, k) {
      v = this._.replace(v, k, `<span>${k}</span>`)
      return v
    }
  }
}
</script>
<style scoped>
  .dropdown{
    position: absolute;
    border: 1px solid #ddd;
    color: #333;
    /*width: 100%;*/
    left: 0;
    /*top: 45px;*/
    top: 100%;
    z-index: 1000;
    min-height: 120px;
    background-color: #fff;
    box-shadow: 2px 2px 2px 0 rgba(215, 215, 215, 0.50);
    border-radius: 3px;
    /*font-size: 12px;*/
  }
  .dropdown-title{
    background-color: #F7F7FB;
    border-radius: 3px;
    height: 28px;
    line-height: 28px;
    position: relative;
  }
  .close{
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    width: 10px;
    height: auto;
    right: 10px;
    cursor: pointer;
  }
  .dropdown-content{
    background-color: #fff;
    position: relative;
  }
  .dropdown >>> .x-tabs-nav{
    border-color: #eee;
    margin-bottom: 10px;
  }
  .dropdown >>> .x-tabs-tabbar{
    background-color: #0774b5;
    height: 2px;
  }
  .dropdown >>> .x-tabs-tabpane{
    padding: 0 2px;
  }
  .dropdown >>> .x-tabs-tab{
    /*font-size: 11px;*/
    font-size: 15px;
    color: #999;
  }
  .dropdown >>> .x-tabs-nav .x-tabs-tab:nth-of-type(1){
    padding-right: 0;
    position: relative;
    left: -14px;
  }
  .dropdown >>> .x-tabs-tab-active{
    color: #0774b5;
  }
  .dropdown >>> .ivu-row{
    /*font-size: 11px;*/
    font-size: 14px;
  }
  .dropdown >>> .ivu-row:last-child{
    margin-bottom: 0;
  }
  .dropdown >>> .ivu-row a{
    color: #333;
  }
  .dropdown >>> .ivu-row a:hover{
    color: #333;
  }
  .dropdown >>> .ivu-row a:after{
    background-color: #333;
    top:inherit;
    bottom: 0;
  }
  .dropdown >>> .ivu-col{
    padding-bottom: 3px;
    margin-bottom: 8px;
    height: 20px;
    line-height: 20px;
    font-size: 15px;
  }
  .dropdown >>> .ivu-col.active{
    background-color: #0774b5;
  }
  .dropdown >>> .ivu-col.active a{
    color: #fff;
  }
  .dropdown >>> .ivu-col.active a:hover{
    color: #fff;
    text-decoration: none;
  }
  .dropdown >>> .ivu-col.active a:after{
    width: 0;
    height: 0;
  }
  .dropdown >>> .search-input-section-item{
    margin-bottom: 6px;
  }
  .dropdown >>> .dropdown-content-history{
    margin-top: 10px;
  }
  .scroll-view {
    /* -- Attention: This line is extremely important in chrome 55+! -- */
    touch-action: none;
    /* -- Attention-- */
    /*position: fixed;*/
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }
  ul li{
    margin: 8px 0;
  }
  ul li:first-child{
    margin-top: 0;
  }
  ul li:last-child{
    margin-bottom: 0;
  }
  ul li a{
    color: #151515;
    /*font-size: 11px;*/
    font-size: 15px;
    display: block;
    width: 120px;
    text-align: left;
    margin: 0 auto;
  }
  ul li a:hover{
    /*color: #666;*/
    color: #0774b5;
    text-decoration: none;
  }
  ul li a:after{
    width: 0;
    height: 0;
  }
  ul li a >>> span{
    color: #0774b5;
  }
  ul li.empty{
    text-align: center;
    margin-top: 20px;
  }
  ul li.empty i{
    color: #c1c0c0;
    /*font-size: 12px;*/
    font-size: 14px;
    font-style: italic;
  }
</style>
<style module>
  .dropdownContentPadding{
    padding: 8px 18px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ExportDropdown.vue